// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.FcPositiveDynamic = function FcPositiveDynamic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1",
      "viewBox": "0 0 48 48",
      "enableBackground": "new 0 0 48 48"
    },
    "child": [{
      "tag": "g",
      "attr": {
        "fill": "#00BCD4"
      },
      "child": [{
        "tag": "rect",
        "attr": {
          "x": "19",
          "y": "22",
          "width": "10",
          "height": "20"
        }
      }, {
        "tag": "rect",
        "attr": {
          "x": "32",
          "y": "8",
          "width": "10",
          "height": "34"
        }
      }, {
        "tag": "rect",
        "attr": {
          "x": "6",
          "y": "30",
          "width": "10",
          "height": "12"
        }
      }]
    }, {
      "tag": "g",
      "attr": {
        "fill": "#3F51B5"
      },
      "child": [{
        "tag": "polygon",
        "attr": {
          "points": "11,8 21,18 21,8"
        }
      }, {
        "tag": "rect",
        "attr": {
          "x": "11",
          "y": "8.9",
          "transform": "matrix(-.707 -.707 .707 -.707 10.879 36.506)",
          "width": "4",
          "height": "14.1"
        }
      }]
    }]
  })(props);
};